import { memo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, IconButton, Tooltip } from '@mui/material'
import { ClearIcon } from '@mui/x-date-pickers'

import { TOOLTIP_SLOT_PROPS } from '../consts'

type ClearCellProps = {
  isDisabled?: boolean
  hasRowData: boolean
  onClearRow: () => void
}

export const ClearCell = memo(({ isDisabled, hasRowData, onClearRow }: ClearCellProps) => {
  const { t } = useTranslation()

  const handleClearClick = useCallback(() => {
    onClearRow()
  }, [onClearRow])

  if (!hasRowData) return <Box sx={{ width: 28, height: 28 }} />

  return (
    <Tooltip
      arrow
      placement='bottom'
      slotProps={TOOLTIP_SLOT_PROPS}
      title={t('commandParameters.table.tooltips.clearRow')}
    >
      <span>
        <IconButton disabled={isDisabled} size='small' onClick={handleClearClick}>
          <ClearIcon fontSize='small' />
        </IconButton>
      </span>
    </Tooltip>
  )
})

ClearCell.displayName = 'ClearCell'
